document.addEventListener('DOMContentLoaded', () => {
  const open = document.querySelector('.header-mobile-menu__trigger');
  const close = document.querySelector('.mobile-menu__close-trigger');
  const menu = document.querySelector('.mobile-menu');

  if (!open || !menu || !close) return;

    open.addEventListener('click', () => {
        menu.classList.toggle('open');
    });

    close.addEventListener('click', () => {
        menu.classList.toggle('open');
    });
});
